module.exports = __webpack_public_path__ + "img/flavor1.2e608a09.svg";